import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const ContentContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.sz.s8};

    @media (max-width: ${theme.sz.s}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s26};
    padding: ${theme.sz.s4};
    width: auto;
    margin-bottom: ${theme.sz.s6};

    @media (max-width: ${theme.sz.s}) {
      margin-bottom: ${theme.sz.s3};
    }
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    color: ${theme.co.secondary0};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s3};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary20};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s6};
  `,
);

export const LockIcon = styled(Icon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s5};
    padding-bottom: ${theme.sz.s05};
    margin-right: ${theme.sz.s2};
  `,
);
